import { PriceLabel, PriceLabelWithTax } from "@/components/features/shared/utils"

export const SubtotalsData = ({ amountPayed, amountOwed, interestAmount, amountToCharge }
  : { amountPayed: number, amountOwed: number, interestAmount?: number, amountToCharge?: number }) => {
  return <div className="p-6 bg-gray-50 mt-auto">
    <div className="space-y-3">
      {amountPayed > 0 && (
        <div className="flex justify-between items-center text-sm font-medium text-gray-600">
          <span>Monto abonado</span>
          <PriceLabel price={amountPayed} />
        </div>
      )}
      {amountOwed > 0 && (
        <div className="flex justify-between items-center text-sm font-medium text-gray-600">
          <span>Saldo restante</span>
          <PriceLabel price={amountOwed} />
        </div>
      )}
      {!!interestAmount && interestAmount! > 0 && (
        <div className="space-y-3 border-gray-200">
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-gray-900">Subtotal</span>
            <div className="text-sm font-medium text-gray-900">
              <PriceLabel price={amountToCharge! - interestAmount!} />
            </div>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-gray-900">Interés tarjeta</span>
            <div className="text-sm font-medium text-gray-900">
              <PriceLabelWithTax price={interestAmount} taxRate={21} />
            </div>
          </div>
        </div>
      )}
      {/* {(interestAmount || 0) > 0 && (
        <div className="flex justify-between items-center pt-3 border-t border-gray-200 mt-2">
          <span className="text-base font-bold text-gray-900">Interés tarjeta</span>
          <div className="text-xl font-bold text-gray-900">
            <PriceLabelWithTax price={interestAmount!} taxRate={21} />
          </div>
        </div>
      )} */}
      <div className="flex justify-between items-center pt-3 border-t border-gray-200 mt-2">
        <span className="text-base font-bold text-gray-900">Total a Cobrar</span>
        <div className="text-xl font-bold text-gray-900">
          <PriceLabel price={amountToCharge!} />
        </div>
      </div>
    </div>
  </div>
}